(function() {
  "use strict";
  
  const SELECTORS = {
    item: "[data-progress-item]",
    number: "[data-progress-number]",
    bar: "[data-progress-bar]",
    line: "[data-progress-line]"
  };
  
  const CLASSES = {
    active: "is-active"
  };

  if (!customElements.get("progress-features-component")) {
    customElements.define("progress-features-component", class extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll(SELECTORS.item);
        this.numbers = this.querySelectorAll(SELECTORS.number);
        this.progressBar = this.querySelector(SELECTORS.bar);
        this.progressLine = this.querySelector(SELECTORS.line);
        this.requestAnimation = null;
        this.isScrollEnabled = false;
        this.sectionTop = 0;
        this.sectionBottom = 0;
        this.sectionHeight = 0;
        
        this.scrollEvent = () => this.handleScroll();
        this.resizeEvent = () => this.handleResize();
      }

      connectedCallback() {
        if (this.items.length && this.progressLine) {
          this.calculateDimensions();
          this.positionNumbers();
          this.updateProgress();
          this.isScrollEnabled = true;
          
          document.addEventListener("theme:scroll", this.scrollEvent);
          window.addEventListener("scroll", this.scrollEvent, { passive: true });
          window.addEventListener("resize", this.resizeEvent);
        }
      }

      handleResize() {
        this.calculateDimensions();
        this.positionNumbers();
        this.updateProgress();
      }

      calculateDimensions() {
        const section = this.closest("section");
        if (section) {
          const rect = section.getBoundingClientRect();
          this.sectionTop = rect.top + window.scrollY;
          this.sectionBottom = rect.bottom + window.scrollY;
          this.sectionHeight = this.sectionBottom - this.sectionTop;
        } else {
          const rect = this.getBoundingClientRect();
          this.sectionTop = rect.top + window.scrollY;
          this.sectionBottom = rect.bottom + window.scrollY;
          this.sectionHeight = this.sectionBottom - this.sectionTop;
        }
      }

      positionNumbers() {
        this.numbers.forEach((numberEl, index) => {
          const item = this.items[index];
          if (item) {
            const itemRect = item.getBoundingClientRect();
            const section = this.closest("section");
            if (section) {
              const sectionTop = section.getBoundingClientRect().top + window.scrollY;
              const numberTop = itemRect.top + window.scrollY - sectionTop + item.offsetHeight / 2;
              numberEl.style.top = `${numberTop}px`;
            } else {
              numberEl.style.top = `${item.offsetTop + item.offsetHeight / 2}px`;
            }
          }
        });
      }

      handleScroll() {
        if (!this.requestAnimation) {
          this.requestAnimation = requestAnimationFrame(() => this.updateProgress());
        }
      }

      updateProgress() {
        this.requestAnimation = null;
        
        if (!this.progressLine || !this.sectionHeight) {
          return;
        }

        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        
        // Progress calculation:
        // Start: when section top enters viewport (scrollY = sectionTop)
        // End: when section bottom becomes visible at bottom of viewport (scrollY = sectionBottom - viewportHeight)
        const progressStart = this.sectionTop;
        const progressEnd = this.sectionBottom - viewportHeight;
        const totalRange = progressEnd - progressStart;
        
        let progress = 0;
        
        if (scrollY <= progressStart) {
          // Section not yet entered viewport
          progress = 0;
        } else if (scrollY >= progressEnd) {
          // Section bottom is visible (at or past bottom of viewport)
          progress = 100;
        } else {
          // Section is being scrolled through
          progress = ((scrollY - progressStart) / totalRange) * 100;
        }
        
        // Clamp between 0 and 100
        progress = Math.max(0, Math.min(100, progress));
        
        // Update progress bar height
        this.progressLine.style.setProperty("--progress-height", `${progress}%`);

        // Update active states for numbers and items
        let activeIndex = 0;
        this.items.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.top + window.scrollY + item.offsetHeight / 2;
          const viewportCenter = window.scrollY + viewportHeight / 2;
          
          if (itemCenter <= viewportCenter) {
            activeIndex = index;
            const numberEl = this.numbers[index];
            if (numberEl) {
              // Remove active from all
              this.numbers.forEach(el => el.classList.remove(CLASSES.active));
              // Add active to current
              numberEl.classList.add(CLASSES.active);
              item.classList.add("is-active");
            }
          } else {
            item.classList.remove("is-active");
            const numberEl = this.numbers[index];
            if (numberEl) {
              numberEl.classList.remove(CLASSES.active);
            }
          }
        });
      }

      disconnectedCallback() {
        if (this.isScrollEnabled) {
          this.isScrollEnabled = false;
          document.removeEventListener("theme:scroll", this.scrollEvent);
          window.removeEventListener("scroll", this.scrollEvent);
          window.removeEventListener("resize", this.resizeEvent);
        }
      }
    });
  }
})();